import React, { useEffect, useRef, useState } from 'react';
import './Loading.css';

const CA_CIRCLE_WORDS = [
    'Career', 'Growth', 'Mentor', 'Success', 'Network'
];

const Loading = ({ isLoading, variant = 'simple' }) => {
    const [isVisible, setIsVisible] = useState(isLoading);
    const hideTimeoutRef = useRef(null);
    const activeVariantRef = useRef(variant);

    useEffect(() => {
        if (isLoading) {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            activeVariantRef.current = variant;
            setIsVisible(true);
        } else {
            const delay = activeVariantRef.current === 'full' ? 10000 : 0;
            if (delay > 0) {
                hideTimeoutRef.current = setTimeout(() => {
                    setIsVisible(false);
                    hideTimeoutRef.current = null;
                }, delay);
            } else {
                setIsVisible(false);
            }
        }

        return () => {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
        };
    }, [isLoading, variant]);

    if (!isVisible) return null;
    
    if (variant === 'full') {
        const ringRadii = [60, 100, 150, 200, 260];
        const wordAngles = [200, 45, 280, 120, 330];

        return (
            <div className="ca-radar-overlay">
                <h1 className="ca-radar-title">CA Connect</h1>
                
                <div className="ca-radar-container">
                    {/* Static concentric rings */}
                    {ringRadii.map((radius, i) => (
                        <div
                            key={`ring-${i}`}
                            className="ca-radar-ring"
                            style={{
                                width: `${radius * 2}px`,
                                height: `${radius * 2}px`,
                            }}
                        />
                    ))}
                    
                    {/* Center dot */}
                    <div className="ca-radar-center">
                        <div className="ca-radar-dot" />
                    </div>
                    
                    {/* Words positioned on each ring */}
                    {CA_CIRCLE_WORDS.map((word, index) => {
                        const radius = ringRadii[index];
                        const angleDeg = wordAngles[index];
                        const angleRad = (angleDeg * Math.PI) / 180;
                        const x = Math.cos(angleRad) * radius;
                        const y = Math.sin(angleRad) * radius;
                        
                        return (
                            <div
                                key={word}
                                className="ca-radar-word"
                                style={{
                                    transform: `translate(${x}px, ${y}px)`,
                                    animationDelay: `${index * 0.4}s`,
                                }}
                            >
                                {word}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
    
    return null;
};

export default Loading;
